import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Post from "../components/post"

const BlogPost = props => {
  const { data } = props

  return (
    <Layout>
      <Post
        title={data.post.title}
        body={data.post._rawBody}
        date={data.post.publishedAt}
        featuredimage={data.post.mainImage.asset.fluid}
        tags={data.post.tags}
      />
    </Layout>
  )
}

export default BlogPost

export const pageQuery = graphql`
  query PostQuery($slug: String!) {
    post: sanityPost(slug: { current: {eq: $slug} }) {
      publishedAt
      featured
      slug {
        current
      }
      title
      tags {
        id
        name
      }
      id
      _rawBody(resolveReferences: {maxDepth: 10})
      body {
          _key
          _type
          style
          list
          children {
            _key
            _type
            marks
            text
          }
        }
      mainImage {
          asset {
            fluid(maxWidth: 500) {
              ...GatsbySanityImageFluid
            }
          }
      }
  }
  }
`
